// Enum: lime._internal.format.BMPType

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

// Imports

var $estr = require("./../../../estr_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;

// Definition

var BMPType = $hxEnums["lime._internal.format.BMPType"] = { __ename__ : "lime._internal.format.BMPType", __constructs__ : ["RGB","BITFIELD","ICO"]
  ,RGB: {_hx_index:0,__enum__:"lime._internal.format.BMPType",toString:$estr}
  ,ICO: {_hx_index:2,__enum__:"lime._internal.format.BMPType",toString:$estr}
  ,BITFIELD: {_hx_index:1,__enum__:"lime._internal.format.BMPType",toString:$estr}
};

exports.default = BMPType;